import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { AuthForm } from '@/components/auth/AuthForm';

export default function Auth() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <AuthLayout subtitle={t('auth.welcomeBack')}>
      <AuthForm onForgotPassword={() => navigate('/forgot-password')} />
    </AuthLayout>
  );
}
